import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
    MainFilters,
    MainFiltersParams,
} from 'components/main-filters/main-filters';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { EventMasterTable } from '../components/event-master';
import { AddEventMasterModal } from '../components/event-master/add-event-master-modal/add-event-master-modal';
import { EventsMasterFilterForm } from '../components/event-master-filter/event-master-filter';
import { EventFilterFormPaginated, EventMasterFilterFormValues } from '../components/type';
import { useGetEventMaster } from '../use-cases/get-event-master';

const { useBreakpoint } = Grid;

const initialFilterValues: EventMasterFilterFormValues = {
    title: undefined,
};

export const EventMasterView = () => {
    const screens = useBreakpoint();
    const permissions = usePermissions();
    const { params, updateParams, resetPage } =
        usePaginationParams<EventFilterFormPaginated>({
            page: 1,
            size: 10,
            order_by: '-rank',
            ...initialFilterValues,
        });

    const { data, isFetching, refetch } = useGetEventMaster(params, { retry: false });
    const [eventEditData, setEventEditData] = useState<any>(undefined);

    const shouldHandleFieldCreation = permissions?.fields.add;

    const handleFiltersChange = (values: EventMasterFilterFormValues) => {
        updateParams(values);
        resetPage();
        refetch();
    };

    const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
        updateParams(mainParams);
        resetPage();
    };
    const [showEventMasterModal, setShowEventMasterModal] = useState(false);
    const formId = 'events-filters-form';

    const handleCloseModal = () => {
        setShowEventMasterModal(false);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = () => {
        setShowEventMasterModal(true);
        document.body.style.overflow = 'hidden';
    }

    return (
        <>
            <ContentTopBar
                title={"Event Master"}
                renderHeadingContent={
                    <MainFilters onChange={handleMainFiltersChange} />
                }
                renderButtons={
                    <>
                        {shouldHandleFieldCreation ? (
                            <>
                                <Button
                                    icon={!screens.xs ? <PlusOutlined /> : undefined}
                                    type='primary'
                                    onClick={handleOpenModal}
                                >
                                    {"Add Event Master"}
                                </Button>
                                <div className={`cstmrightmdl ${showEventMasterModal && "show"}`}>
                                    <AddEventMasterModal refetch={refetch} onClose={handleCloseModal} eventEditData={eventEditData} />

                                </div>

                            </>
                        ) : null}
                    </>
                }
            />

            <ContentFilters formId={formId}>
                <EventsMasterFilterForm
                    formId={formId}
                    handleFilter={handleFiltersChange}
                    initialValues={initialFilterValues}
                />
            </ContentFilters>

            <EventMasterTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}
                eventEditData={eventEditData}
                setEventEditData={setEventEditData}
            />
            <Outlet />
        </>
    );
};


